export type NavigateFunction = (href: string) => void;

export const navigateTo = (href: string) => {
  window.location.href = href;
};
